<template>
    <input class="edit-line ml-2 mr-3" type="text" v-model="item[keyValue]">
</template>
<script>
export default {
	props: {
		item: {
			type: Object
		},
		keyValue: String
	},
	mounted() {
		this.$el.focus();
	},
};
</script>
<style lang="scss" scoped>
@import './input.component';
</style>
